// extracted by mini-css-extract-plugin
module.exports = {"NextButton":"NextButton_NextButton__tMUg6","backButton":"NextButton_backButton__2abRf","forwardButton":"NextButton_forwardButton__25aJ8"};